import { lazy } from 'react';

const PeriodBudgetPage = lazy(() => import('../pages/PeriodBudget.page'));

const PeriodBudgetRoutes = [
    {
        path: '/period-budget',
        element: <PeriodBudgetPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { PeriodBudgetRoutes };
